import React from 'lib/react';
import {
  EVGrid,
  EVIconButton,
  EVEditOutlined,
  EVTypography,
} from 'lib/components';
import { useSelector } from 'lib/redux';
import { useTranslation } from 'lib/translation';
import history from 'store/CreateHistory';
import { CONTACT_INFORMATION_ROUTE } from 'constants/RouteConstants';
import DashboardRetry from '../../DashboardRetry.component';
import CompanyInfoStyles from './CompanyInfoStyles';

function CompanyInformationDisplay() {
  const { t } = useTranslation();
  const classes = CompanyInfoStyles();
  const {
    companyInformation,
    companyInformationError,
  } = useSelector(({ userData }) => ({
    companyInformation: userData.companyInformation,
    companyInformationError: userData.error.companyInformation,
  }));

  const {
    company, address1, city, state, zip,
  } = companyInformation.address || {};

  return (
    <EVGrid className={classes.topSection}>
      {companyInformationError ? (
        <DashboardRetry
          retryText={t('dashboard__company_info_retry_msg')}
          action="LOAD_COMPANY_INFO"
        />
      )
        : (
          <>
            <EVGrid className={classes.companyNameSection}>
              <EVTypography id="company-name-text" className={classes.companyTitleText}>{company}</EVTypography>
              <EVTypography className={classes.companyAddressText}>{address1}</EVTypography>
              <EVTypography className={classes.companyAddressText}>{`${city}, ${state} ${zip}`}</EVTypography>
            </EVGrid>
            <EVIconButton data-testid="edit-icon" className={classes.editOutlineButton} onClick={() => history.push(CONTACT_INFORMATION_ROUTE)}>
              <EVEditOutlined htmlColor="#009AC5" />
            </EVIconButton>
          </>
        )}
    </EVGrid>
  );
}

export default CompanyInformationDisplay;
